import { LogInPaths } from '@bbkAdminComponents/log-in-flow/log-in-paths';
import { encodeObjectForQuery } from '@bbkAdminRedux/rtkq/rtkq-utils';
import { useLocation } from '@bbkShared/react-router';

export const useSignInRedirect = () => {
  const location = useLocation();

  return {
    url:
      LogInPaths.signIn +
      encodeObjectForQuery({
        redirectUri: location.pathname + location.search,
      }),
  };
};
